import styled from "@emotion/styled";
import colors from "../../styles/colors";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export const ReactDatePickerContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  font-family: Inter;
  .overflow {
    background: red;
  }
  .show-border {
    .react-datepicker__input-container div div div {
      box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.1);
      box-shadow: -2px 0px 6px -1px rgba(0, 0, 0, 0.2);
    }
  }
  .wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    .react-datepicker__input-container {
      div {
        flex-direction: row;
        :focus-within {
          div {
            background-color: ${colors["color-blue-30"]};
          }
        }
        div {
          background-color: white;
        }
      }
    }
    svg {
      path {
        fill: #054bc7 !important;
      }
    }
    .react-datepicker-wrapper {
      width: 100%;
    }

    .react-datepicker-popper {
      position: fixed;
      transform: translate3d(0px, px, 0px);
      padding-bottom: 0.25rem;
      .react-datepicker__triangle {
        display: none;
      }

      .react-datepicker__input-container:focus ~ svg {
        z-index: 1;
      }
      .react-datepicker__month-container {
        .react-datepicker__current-month,
        .react-datepicker-time__header,
        .react-datepicker-year-header {
          font-size: 0.75rem;
          font-family: Inter;
          color: ${colors["color-gray-160"]};
        }
        .react-datepicker__week {
          padding: 4px 8px;
          gap: 10px;
        }
        .react-datepicker__day--today {
          background-color: rgba(188, 209, 245, 1);
          color: ${colors["color-black-100"]};
          font-weight: 400;
        }
        .react-datepicker__day--keyboard-selected,
        .react-datepicker__day--selected {
          background-color: ${colors["color-blue-120"]};
          color: white;
        }
        .react-datepicker__day--highlighted {
          background-color: ${colors["color-white-100"]};
          border: 1px solid rgba(112, 54, 174, 1);
          color: ${colors["color-white-100"]};
        }
        .react-datepicker__day-names {
          margin-bottom: 0;
          margin-top: 0.5rem;
          color: ${colors["color-gray-160"]};
          .react-datepicker__day-name,
          .react-datepicker__day {
            color: ${colors["color-gray-160"]};
          }
        }
      }
    }
  }
`;
export const ReactDatePickerStyled = styled(DatePicker) `
  font-family: Inter;
`;
//# sourceMappingURL=datepicker.styled.js.map